<template>
	<div>

		<div class="row">
			<div class="col-xs">
				<button class="button-edit" @click="close">
					<i class="fa fa-arrow-left"></i> Voltar
				</button>
				<br/><br/>
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput v-model="form.name" label="Nome" icon="fa-user" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput v-model="form.email" label="E-mail" icon="fa-envelope" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormInput v-if="current != 'new'" type="password" v-model="form.password" label="Senha (deixe em branco para manter)" icon="fa-lock" />
				<FormInput v-if="current == 'new'" type="password" v-model="form.password" label="Senha" icon="fa-lock" :required="true" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormSelect :options="{1: 'Administrador', 0: 'Comum'}" v-model="form.is_admin" label="Tipo" icon="fa-user-shield" />
			</div>
		</div>

		<div class="row">
			<div class="col-xs">
				<FormSelect :options="{1: 'Ativo', 0: 'Inativo'}" v-model="form.status" label="Status" icon="fa-check" />
			</div>
		</div>

		<button class="button-create" @click="save">
			<i class="fa fa-save"></i> Salvar
		</button>

	</div>
</template>

<script>
import Api from "@/lib/Api";

import FormInput from "@/components/FormInput";
import FormSelect from "@/components/FormSelect";

export default {
	name: "AdminCompanyUserForm",

	props: [ "current", "company" ],

	components: { FormInput, FormSelect },

	data: function() {
		let data = {
			loading: false,
		};

		if (this.current == 'new') {
			data.form = {
				email: '',
				name: '',
				password: '',
				status: '1',
				is_admin: '1',
				fk_company: this.company,
			};
		} else {
			data.form = {
				email: this.current.email,
				name: this.current.name,
				password: '',
				status: this.current.status,
				is_admin: this.current.is_admin,
			}
		}

		return data;
	},

	methods: {
		save: async function() {
			let delta = {};

			if (this.current == 'new') {
				delta = this.form;
			} else {
				if (this.form.email != this.current.email) delta.email = this.form.email;
				if (this.form.name != this.current.name) delta.name = this.form.name;
				if (this.form.password != '') delta.password = this.form.password;
				if (this.form.status != this.current.status) delta.status = this.form.status;
				if (this.form.is_admin != this.current.is_admin) delta.is_admin = this.form.is_admin;

				if (Object.keys(delta) == 0) {
					this.close();
					return;
				}

				delta.fk_company = this.company;
				delta.id = this.current.id;
			}

			this.loading = true;
			let res = await Api.post_admin("user/save", delta);
			this.loading = false;

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

			this.close();
			this.$notification.success("Salvo com sucesso.");
			this.$emit('load');
		},



		get_delta: function() {
			if (!this.id) return false;

			let delta = {};

			if (this.name != this.current.name) {
				delta.name = this.name;
			}

			if (this.email != this.current.email) {
				delta.email = this.email;
			}

			if (this.status != this.current.status) {
				delta.status = this.status;
			}

			if (this.password != '') {
				delta.password = this.password;
			}

			if (this.is_admin != this.current.is_admin) {
				delta.is_admin = this.is_admin;
			}

			if (Object.keys(delta).length == 0) return false;
			
			delta.id = this.current.id;
			delta.fk_company = this.company;

			return delta;
		},



		close: function() {
			this.$emit("back");
		}
	}
}
</script>

<style scoped>

.button-create {
	float: right;
}

</style>